import { useCallback } from "react";
import { logEvent } from "react-migration/lib/util/logEvent";
import { Nullable } from "src/js/types/Nullable";
import clsx from "clsx";

type FileInputProps = {
  onSelectFile: (file?: File) => void;
  value?: Nullable<File>;
};

export const FileInput = ({ onSelectFile, value }: FileInputProps) => {
  const onFileChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.currentTarget.files?.[0];
      logEvent("Site Report - Upload Logo - clicked");

      onSelectFile(file);
    },
    [onSelectFile]
  );

  const onDeleteClick = useCallback(() => onSelectFile(undefined), [onSelectFile]);

  return (
    <div className="relative flex w-full bg-white border rounded-sm border-blue-grey-200 hover:border-blue-grey-300">
      <div className="grow">
        <div className={clsx("px-3 py-2", { "text-blue-grey-400": !value })}>{value?.name ?? "Upload a logo..."}</div>
      </div>

      {value ? (
        <button onClick={onDeleteClick} className="flex items-center px-2 shrink-0 ">
          <i className="text-xl icon-lt-delete-bin-line" />
        </button>
      ) : (
        <div className="flex items-center px-2 shrink-0">
          <i className="text-xl icon-lt-upload-cloud-2-line" />
        </div>
      )}
      {!value && (
        <input type="file" className="absolute top-0 w-full h-full opacity-0 cursor-pointer" onChange={onFileChange} />
      )}
    </div>
  );
};
